{
 "labels": {
  "lang": {
   "x": 734,
   "y": 66,
   "w": 105,
   "h": 31
  },
  "btn.google": {
   "x": 296,
   "y": 977,
   "w": 406,
   "h": 38
  },
  "btn.apple": {
   "x": 333,
   "y": 1122,
   "w": 331,
   "h": 37
  },
  "btn.email": {
   "x": 319,
   "y": 1267,
   "w": 358,
   "h": 29
  }
 },
 "legal": {
  "x": 258,
  "y": 1378,
  "w": 423,
  "h": 78
 }
}